import { Experiment } from '@ms/yammer-data/dist/state/types';
import { isIE } from '@ms/yammer-web-core-ui/dist/util/browserDetector';

import { useExperimentTreatmentWithoutReporting } from '../experiments';

import { useIsDismissed } from './selectors';

type UseShouldShowBanner = (isDismissSuppressed: boolean) => boolean;
export const useShouldShowBanner: UseShouldShowBanner = (isDismissSuppressed) => {
  const isDismissed = useIsDismissed();
  const isIE11 = isIE();
  const isIE11DeprecationBannerEnabled =
    useExperimentTreatmentWithoutReporting(Experiment.IE11DeprecationBanner) === 'enabled';
  const isNotDismissed = isDismissSuppressed || !isDismissed;

  if (isIE11 && isIE11DeprecationBannerEnabled && isNotDismissed) {
    return true;
  }

  return false;
};
